// Dual path hero front-end: a tiny scroll parallax that drifts the background
// image. Mirrors the Lovable DualPathHero effect ( offset = -rect.top * 0.35 )
// and is entirely skipped when the user prefers reduced motion. Loaded
// on-demand ( view_script ) only when the block is on the page.

const SELECTOR = '.b-dual-path-hero';
const IMAGE_SELECTOR = '.b-dual-path-hero__bg-image';

/**
 * Bind the scroll/resize parallax to a single hero section.
 *
 * @param {HTMLElement} section Block root element.
 *
 * @return {void}
 */
const initParallax = ( section ) => {

	const image = section.querySelector( IMAGE_SELECTOR );

	if ( ! image ) {

		return;

	}

	let raf = 0;

	/**
	 * Recompute and apply the image offset while the section is in view.
	 *
	 * @return {void}
	 */
	const update = () => {

		raf = 0;

		const rect = section.getBoundingClientRect();

		// Only animate while the section is within the viewport range.
		if ( rect.bottom < 0 || rect.top > window.innerHeight ) {

			return;

		}

		const offset = -rect.top * 0.35;
		image.style.transform = `translate3d(0, ${ offset }px, 0) scale(1.05)`;

	};

	/**
	 * Throttle updates to one per animation frame.
	 *
	 * @return {void}
	 */
	const onScroll = () => {

		if ( raf ) {

			return;

		}

		raf = window.requestAnimationFrame( update );

	};

	update();
	window.addEventListener( 'scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', onScroll );

};

/**
 * Initialise every hero on the page, unless reduced motion is preferred.
 *
 * @return {void}
 */
const init = () => {

	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {

		return;

	}

	document.querySelectorAll( SELECTOR ).forEach( initParallax );

};

if ( document.readyState !== 'loading' ) {

	init();

} else {

	document.addEventListener( 'DOMContentLoaded', init );

}
